import request from '../utils/request';

// 获取tab数据
export function tabMeans(index) {
    return request({
        url:"/frontPage/newslist",
        method:"get",
        params:{
            index
        }
    })
}

// 详情页请求
export function particularData(ID) {
    return request({
        url:"/frontPage/getNewsByID",
        method:"get",
        params:{
            ID
        }
    })
}

// 会员机构名录
export function membersData(params) {
    return request({
        url:"/frontPage/frontInstitutionPage",
        method:"get",
        params
    })
}

// 联系我们
export function contactsData(params) {
    return request({
        url:"/frontPage/saveComplaints",
        method:"get",
        params
    })
}

// 获取详情资料
export function getNewData(ID) {
    return request({
        url:"/frontPage/getNew",
        method:"get",
        params:{
            ID
        }
    })
}

/**
 * 下载execl名录
 */
export const downloadFile = (url,ext, params, name) => {
    return request({
        method: 'get',
        url: url,
        params,
        responseType: 'blob', //二进制流
    }).then(res => {
        // 处理返回的文件流
        const content = res;
        const blob = new Blob([content], { type: 'application/vnd.ms-excel;charset=utf-8' });
        var date =
            new Date().getFullYear() +
            "" +
            (new Date().getMonth() + 1) +
            "" +
            new Date().getDate() +
            "" +
            new Date().getHours() +
            "" +
            new Date().getMinutes() +
            "" +
            new Date().getSeconds() +
            "" +
            new Date().getMilliseconds();
            
        var fileName = name? name : '鉴定机构名录'+ date + "." + ext;
        
        if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
        } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
        }
    });
};

export const getRecordExport= (params) => {
    return downloadFile('/frontPage/exportHttp',"xlsx", params)
}

// 详情下载
export const downloadpic= (ext,params,name) => {
    return downloadFile('/frontPage/downloadpic',ext, params, name)
}